module.exports = __webpack_public_path__ + "static/media/white.807bad99.svg";